import { seo } from '../seo';
export { WebsiteHostingAgreementPage as default } from '../../src/pages/Legal/WebsiteHostingAgreementPage';
export const meta = () => seo('legal.websiteHostingAgreement');
